import React from "react";
import type { ClassInterface } from "../../types/class.interface";
import ClassRow from "./ClassRow";

type ClassListWrapperProps = {
  classes: ClassInterface[];
  onFavoriteChange?: (classId: string, isFavorite: boolean) => void;
  liveStreamClassFilter?: boolean;
};

const ClassWrapper: React.FC<ClassListWrapperProps> = ({ classes, onFavoriteChange, liveStreamClassFilter }) => {
  return (
    <div className="flex flex-col">
      {classes.map((classItem) => (
        <ClassRow 
          key={classItem.id} 
          classItem={classItem} 
          liveStreamClassFilter={liveStreamClassFilter}
          onFavoriteChange={onFavoriteChange}
        />
      ))}
    </div>
  );
};

export default ClassWrapper;
